module.exports = __webpack_public_path__ + "img/public/SiteIcons/wishlistOn.svg?49bd3769";